import { PointTuple } from "leaflet";

export const findFurthestPointsPair = (points: PointTuple[]): [PointTuple, PointTuple] => {
  let maxDistance = 0;
  let maxDistancePoints: [PointTuple, PointTuple] = [
    [0, 0],
    [0, 0]
  ];

  for (let i = 0; i < points.length - 1; i++) {
    const point1 = points[i];

    for (let j = i + 1; j < points.length; j++) {
      const point2 = points[j];

      const distanceSquared =
        Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2);

      if (distanceSquared > maxDistance) {
        maxDistance = distanceSquared;
        maxDistancePoints = [point1, point2];
      }
    }
  }

  return maxDistancePoints;
};
